import React from "react";

import Button from "devextreme-react/button";

import { useFxDispatch, useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";
import {
  lockForMessageStart,
  xapiSpvDownloadAsPdf,
  xapiSpvDownloadOriginalZip,
} from "@app/statefx/xThunks/n-file-sys-opts";

export const SpvShortOps = () => {
  const dispatch = useFxDispatch();
  const { currentRecord: crtMessage = {} } = useFxSelector(
    schema.uiSpvMain.select
  );

  const downloadZip = () => {
    if (!crtMessage.FXM_ID) return;
    dispatch(xapiSpvDownloadOriginalZip(JSON.stringify(crtMessage)));
  };
  const openPdf = () => {
    if (!crtMessage.FXM_ID) return;
    dispatch(lockForMessageStart());
    dispatch(xapiSpvDownloadAsPdf(JSON.stringify(crtMessage)));
  };
  return (
    <div className="dx-card">
      <div className="dx-fieldset">
        <div className="dx-fieldset-header">Inspectarea mesajului SPV</div>
        <div className="dx-field">
          <div className="dx-field-label">{"Export"}</div>
          <Button
            text="Deschide PDF"
            icon="exportpdf"
            type="default"
            stylingMode="outlined"
            width={150}
            onClick={openPdf}
            disabled={(crtMessage.FXM_ID || 0) < 1}
          ></Button>
        </div>
        <div className="dx-field">
          <div className="dx-field-label">{"Mesaj original (.zip)"}</div>
          <Button
            text="Descarcă ZIP"
            icon="download"
            type="default"
            stylingMode="outlined"
            width={150}
            onClick={downloadZip}
            disabled={(crtMessage.FXM_ID || 0) < 1}
          ></Button>
        </div>
      </div>
    </div>
  );
};
